<template>
  <div
    ref="stars"
    :class="['star-rating', { 'star-rating--interactive': isInteractive }]"
    v-on="isInteractive ? { mouseleave: () => setInteractiveRating(-1) } : {}"
  >
    <IconStar
      v-for="n in starTotal"
      :key="n"
      :isInactive="n > displayedRating"
      :isSmall="isSmall"
      :hasBorderOnly="isInteractive && n > displayedRating"
      :hasAlert="isInteractive && hasAlert && displayedRating < 0"
      v-on="
        isInteractive
          ? { click: () => setSavedRating(n), mouseenter: () => setInteractiveRating(n) }
          : {}
      "
    />
    <slot name="below"></slot>
  </div>
</template>

<script>
import Vue from 'vue'
import IconStar from '@/components/_shared/IconStar.vue'
import propsFiveStars from '@/components/_shared/Form/FiveStarsRating/props-five-stars'

export default {
  name: 'FiveStarsRating',
  components: { IconStar },

  props: { ...propsFiveStars },

  data() {
    return {
      starTotal: 5,
      interactiveRating: -1,
    }
  },

  computed: {
    displayedRating() {
      return this.interactiveRating >= 0 ? this.interactiveRating : this.rating
    },
  },

  mounted() {
    if (this.rating < 0 && !this.isInteractive) {
      Vue.util.warn('Missing required prop: "rating"', this)
    }
  },

  methods: {
    getFieldEl() {
      return this.$refs.stars
    },

    focus() {
      this.getFieldEl()?.focus()
    },

    setInteractiveRating(rating) {
      if (!this.isDisabled) this.interactiveRating = rating
    },

    setSavedRating(rating) {
      this.$emit('update:rating', rating)
    },
  },
}
</script>

<style lang="scss" scoped>
.star-rating {
  display: inline-block;
  font-size: 0;
  white-space: nowrap;

  &--interactive {
    cursor: pointer;
  }
}
</style>
